export default "__VITE_ASSET__DTPErYKI__"